module.exports = __webpack_public_path__ + "img/totally-radio-80s.c4829121.png";